<template>
    <div>
        <div class="ui-header-left">
            <!-- 01.侧边栏收缩 Start -->
            <el-dropdown>
                <el-dropdown-menu></el-dropdown-menu>
                <el-button @click="clickCollapse">
                    <i :class="this.$store.state.sideCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                </el-button>

            </el-dropdown>
            <!-- 01.侧边栏收缩 End -->
        </div>
        <div class="ui-header-right">
            <!-- 02.全屏/取消 Start -->
            <el-dropdown>
                <el-dropdown-menu></el-dropdown-menu>
                <el-button @click="clickScreen">
                    <i :class="isScreenFull?'ion-md-contract':'ion-md-expand'"></i>
                </el-button>
            </el-dropdown>
            <!-- 02.全屏/取消 End -->
            <!-- 03.通知/消息 Start -->
            <el-dropdown>
                <el-button @click="clickNews">
                    <i class="ion-ios-notifications"></i>
                </el-button>
                <el-dropdown-menu class="ui-header-news" slot="dropdown">
                    <el-tabs v-model="activeNews" type="border-card" stretch>
                        <el-tab-pane name="notice">
                            <span slot="label">通知<span>({{ noticeNumber }})</span></span>
                            <ul class="ui-header-news-content ui-news-list">
                                <el-scrollbar>
                                    <el-empty description="没有任何通知" v-if="noticeNumber===0"></el-empty>
                                    <li v-else v-for="(item,index) in noticeTable" :key="index">
                                        <router-link :to="'/news-list?id='+item.id" @click="getStateNews(item.id)">
                                            <i v-if="item.type===1"
                                               class="icon ion-ios-megaphone ui-background-primary"></i>
                                            <i v-if="item.type===2"
                                               class="icon ion-ios-megaphone ui-background-success"></i>
                                            <i v-if="item.type===3"
                                               class="icon ion-ios-megaphone ui-background-warning"></i>
                                            <i v-if="item.type===4"
                                               class="icon ion-ios-megaphone ui-background-error"></i>
                                            <p class="title" v-html="item.title"></p>
                                            <p class="date" v-html="item.datetime"></p>
                                            <i class="ion-ios-arrow-forward"></i>
                                        </router-link>
                                    </li>
                                </el-scrollbar>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane name="news">
                            <span slot="label">消息<span>({{ newsNumber }})</span></span>
                            <ul class="ui-header-news-content ui-news-list">
                                <el-scrollbar>
                                    <el-empty description="没有任何消息" v-if="newsNumber===0"></el-empty>
                                    <li v-else v-for="(item,index) in newsTable" :key="index">
                                        <router-link :to="'/news-list?id='+item.id" @click="getStateNews(item.id)">
                                            <i v-if="item.type===1"
                                               class="icon ion-ios-megaphone ui-background-primary"></i>
                                            <i v-if="item.type===2"
                                               class="icon ion-ios-megaphone ui-background-success"></i>
                                            <i v-if="item.type===3"
                                               class="icon ion-ios-megaphone ui-background-warning"></i>
                                            <i v-if="item.type===4"
                                               class="icon ion-ios-megaphone ui-background-error"></i>
                                            <p class="title" v-html="item.title"></p>
                                            <p class="date" v-html="item.datetime"></p>
                                            <i class="ion-ios-arrow-forward"></i>
                                        </router-link>
                                    </li>
                                </el-scrollbar>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane name="await">
                            <span slot="label">待办<span>({{ awaitNumber }})</span></span>
                            <ul class="ui-header-news-content ui-await-list">
                                <el-scrollbar>
                                    <el-empty description="没有任何待办" v-if="awaitNumber===0"></el-empty>
                                    <li v-else v-for="(item,index) in awaitTable" :key="index">
                                        <router-link :to="'/news-list?id='+item.id" @click="getStateNews(item.id)">
                                            <p class="title" v-html="item.title"></p>
                                            <p class="date" v-html="item.datetime"></p>
                                            <el-tag v-if="item.type===1" type="primary" size="small" effect="dark">进行中
                                            </el-tag>
                                            <el-tag v-if="item.type===2" type="success" size="small" effect="dark">已完成
                                            </el-tag>
                                            <el-tag v-if="item.type===3" type="warning" size="small" effect="dark">待审批
                                            </el-tag>
                                            <el-tag v-if="item.type===4" type="danger" size="small" effect="dark">已退回
                                            </el-tag>
                                            <i class="ion-ios-arrow-forward"></i>
                                        </router-link>
                                    </li>
                                </el-scrollbar>
                            </ul>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="ui-header-news-button">
                        <el-button type="primary" @click="getEmptyNews">清空全部消息</el-button>
                    </div>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- 03.通知/消息 End -->
            <!-- 04.登录用户 Start -->
            <el-dropdown @command="clickUserMenu">
                <el-button class="ui-header-user">
                    <el-avatar :size="32" :src="loginUser.avatar"></el-avatar>
                    <span class="ui-title">{{ loginUser.user_name }}</span>
                </el-button>
                <el-dropdown-menu class="ui-header-menu" slot="dropdown">
                    <el-dropdown-item icon="ion-ios-paper" command="UserConfig">用户设置</el-dropdown-item>
                    <el-dropdown-item icon="ion-ios-contacts" command="Logout">注销用户</el-dropdown-item>
                    <el-dropdown-item icon="ion-ios-help-circle" command="Recommend">系统介绍</el-dropdown-item>
                    <el-dropdown-item icon="ion-ios-mail" command="BugUpload">BUG反馈</el-dropdown-item>
                    <el-dropdown-item icon="ion-ios-grid" command="About">关于我们</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- 04.登录用户 End -->
            <!-- 05.主题设置 Start -->
            <el-dropdown>
                <el-dropdown-menu></el-dropdown-menu>
                <el-button>
                    <i class="ion-ios-settings"></i>
                </el-button>
            </el-dropdown>
            <!-- 05.主题设置 End -->
        </div>
    </div>
</template>

<script>
    // 引入全屏组件
    import screen_full from 'screenfull'

    export default {
        name: "page_header",
        data() {
            return {
                // 01.全屏/取消全屏
                isScreenFull: false,
                // 02.登录用户信息
                loginUser: {
                    avatar: "",
                    user_name: ""
                },
                // 03.通知/消息列表
                // 03.01.消息列表选中
                activeNews: 'notice',
                // 03.02.通知/消息总数
                allNumber: 0,
                // 03.03.通知列表
                noticeTable: [],
                noticeNumber: 0,
                // 03.04.消息列表
                newsTable: [],
                newsNumber: 0,
                // 03.05.待办列表
                awaitTable: [],
                awaitNumber: 0,
            };
        },
        // 方法集合
        methods: {
            // 01.侧边栏伸缩控制
            clickCollapse() {
                this.$store.state.sideCollapse = !this.$store.state.sideCollapse
                if (this.$store.state.sideCollapse === true) {
                    localStorage.setItem("sideCollapse", true)
                } else {
                    localStorage.setItem("sideCollapse", false)
                }
            },
            // 02.全屏/取消
            clickScreen() {
                this.isScreenFull = !this.isScreenFull
                // 判断浏览器是否支持全屏显示
                if (!screen_full.isEnabled) {
                    this.$message({
                        message: '该浏览器无法进入全屏状态',
                        type: '警告'
                    })
                    return false
                }
                screen_full.toggle()
            },
            // 03.获取登录用户的账号及头像
            getUserContent() {
                this.$api.get('/api/get/login-admin/').then((response) => {
                    this.loginUser.avatar = this.$api_url + '/static/upload' + response.data[0].avatar
                    this.loginUser.user_name = response.data[0].user_name
                })
            },
            // 04.用户列表操作
            clickUserMenu(command) {
                // 用户设置 ( UserConfig )
                if (command === "UserConfig") {
                    this.$router.replace('/manage/user-config')
                }
                // 注销用户 ( Logout )
                if (command === "Logout") {
                    this.$confirm('是否退出系统？', '系统提示', {
                        confirmButtonText: '退出',
                        cancelButtonText: '返回',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get('/api/login/admin-logout/').then((response) => {
                            if (response.code === 200) {
                                this.$message.success(response.message)
                                // 退出成功，将TOKEN清除
                                localStorage.removeItem('Token')
                                localStorage.removeItem("pageOptions")
                                localStorage.removeItem("pageActive")
                                localStorage.removeItem("Permissions")
                                localStorage.removeItem("userPermissions")
                                this.$router.replace('/manage/login')
                            } else {
                                this.$message.error(response.message)
                            }
                        })
                    })
                }
                // 系统介绍 ( Recommend )
                if (command === "Recommend") {
                    console.log("Recommend")
                }
                // BUG反馈 ( BugUpload )
                if (command === "BugUpload") {
                    console.log("BugUpload")
                }
                // 关于我们 ( About )
                if (command === "About") {
                    console.log("About")
                }
            },
            // 05.获取通知/消息列表
            // 05.01.通知列表
            getTableNotice() {
                this.$api.get('/api/get/news-array-notice/').then((response) => {
                    this.noticeTable = response.data
                    this.noticeNumber = response.data.length
                    this.allNumber = this.noticeNumber + this.newsNumber + this.awaitNumber
                })
            },
            // 05.02.消息列表
            getTableNews() {
                this.$api.get('/api/get/news-array-news/').then((response) => {
                    this.newsTable = response.data
                    this.newsNumber = response.data.length
                    this.allNumber = this.noticeNumber + this.newsNumber + this.awaitNumber
                })
            },
            // 05.03.待办列表
            getTableAwait() {
                this.$api.get('/api/get/news-array-await/').then((response) => {
                    this.awaitTable = response.data
                    this.awaitNumber = response.data.length
                    this.allNumber = this.noticeNumber + this.newsNumber + this.awaitNumber
                })
            },
            // 05.04.消息状态修改
            getStateNews(value) {
                this.$api.get('/api/state/news/', {'id': value}).then((response) => {
                    if (response.code === 200) {
                        this.getTableNotice()
                        this.getTableNews()
                        this.getTableAwait()
                    }
                })
            },
            // 05.05.清空通知/列表
            getEmptyNews() {
                this.$api.post('/api/patch/news-empty/').then((response) => {
                    if (response.code === 200) {
                        this.$message.success(response.message)
                    } else if (response.code === 401) {
                        this.$message.warning(response.message)
                    } else {
                        this.$message.error(response.message)
                    }
                })
                // 05.01.通知列表
                this.getTableNotice()
                // 05.02.消息列表
                this.getTableNews()
                // 05.03.待办列表
                this.getTableAwait()
            },
            // 06.打开通知页面
            clickNews() {
                this.$router.replace('/news-list')
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 03.获取登录用户的账号及头像
            this.getUserContent()
            // 05.01.通知列表
            this.getTableNotice()
            // 05.02.消息列表
            this.getTableNews()
            // 05.03.待办列表
            this.getTableAwait()
            // 每分钟检测一次是否有最新的通知
            window.setInterval(() => {
                // 07.01.通知列表
                this.getTableNotice()
                // 07.02.消息列表
                this.getTableNews()
                // 07.03.待办列表
                this.getTableAwait()
            }, 60000)
        },
    }
</script>
